import React from 'react';

const Logo = ({ className = '' }) => {
  return (
    <svg 
      width="220" 
      height="60" 
      viewBox="0 0 440 120" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Icon */}
      <g transform="translate(20,20)">
        <rect 
          x="0" 
          y="0" 
          rx="16" 
          ry="16" 
          width="80" 
          height="80"
          fill="none" 
          stroke="#000000" 
          strokeWidth="4"
        />

        {/* Head */}
        <circle cx="40" cy="26" r="7" fill="#000000" />

        {/* Body */}
        <path 
          d="M24 58 V40 C24 34 28 30 34 30 H46 C52 30 56 34 56 40 V58"
          fill="none"
          stroke="#000000"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </g>

      {/* Brand Text */}
      <text 
        x="120" 
        y="62"
        fontFamily="Poppins, Montserrat, Inter, Segoe UI, Arial, sans-serif"
        fontSize="26"
        fontWeight="700"
        letterSpacing="2"
        fill="#000000"
      >
        AI
      </text>

      <text 
        x="160" 
        y="62"
        fontFamily="Poppins, Montserrat, Inter, Segoe UI, Arial, sans-serif"
        fontSize="36"
        fontWeight="600"
        letterSpacing="0.5"
        fill="#000000"
      >
        Job Mate
      </text>
    </svg>
  );
};

export default Logo;
